<template>
  <div class="text-center pt-2 pb-2 social-networks">
    <ShareNetwork
    network="facebook"
    url="https://www.elnuevodia.com/especiales/la-encuesta-el-nuevo-dia-2023/"
    title="La encuesta de El Nuevo Día "
  >
      <iconFacebook />
    </ShareNetwork>
    
    <ShareNetwork
    network="twitter"
    url="https://www.elnuevodia.com/especiales/la-encuesta-el-nuevo-dia-2023/"
    title="La encuesta de El Nuevo Día "
  >
      <iconTwitter />
    </ShareNetwork>
   
    <ShareNetwork
    network="whatsapp"
    url="https://www.elnuevodia.com/especiales/la-encuesta-el-nuevo-dia-2023/"
    title="La encuesta de El Nuevo Día "
  >
      <iconWhatsapp />
    </ShareNetwork>
  </div>
</template>

<style lang="scss">

  .social-networks {
    a {
      margin: 0 5px;
      padding: 0px 5px 2px 5px;
      border: solid 1px #000;
      border-radius: 50%;
      background: #000;
      color: #fff;
      display: inline-block;
    }
  }

</style>

<script>
  import iconFacebook from '@/components/iconFacebook'
  import iconTwitter from '@/components/iconTwitter'
  import iconWhatsapp from '@/components/iconWhatsapp'

  export default {
    name: 'socialSharing',
    components: {
      iconFacebook,
      iconTwitter,
      iconWhatsapp
    }
  }
</script>